"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appendVideoFragment = void 0;

var toSeconds = function toSeconds(time, fps) {
  return Math.round(time / fps * 100) / 100;
};

var appendVideoFragment = function appendVideoFragment(_ref) {
  var actualSrc = _ref.actualSrc,
      actualFrom = _ref.actualFrom,
      duration = _ref.duration,
      fps = _ref.fps;

  var _a;

  if (actualSrc.startsWith('data:')) {
    return actualSrc;
  }

  var existingHash = Boolean(new URL(actualSrc, (_a = window.location.href) !== null && _a !== void 0 ? _a : 'http://localhost:3000').hash);

  if (existingHash) {
    return actualSrc;
  }

  if (!Number.isFinite(actualFrom)) {
    return actualSrc;
  }

  actualSrc += "#t=".concat(toSeconds(-actualFrom, fps));

  if (!Number.isFinite(duration)) {
    return actualSrc;
  }

  actualSrc += ",".concat(toSeconds(duration, fps));
  return actualSrc;
};

exports.appendVideoFragment = appendVideoFragment;